import React, {useCallback, useEffect} from 'react';
import {Card} from 'react-bootstrap';
import {Route, Switch} from 'react-router-dom';
import {useSubheader} from '../../../_metronic/layout';
import MyTable from '../../../_metronic/layout/components/table/MyTable';
import {
  REVIEWS_RT,
  REVIEWS_RT_DELETE,
  REVIEWS_RT_EDIT,
} from '../../constants/constant-routes';
import {API_GET_ALL_REVIEWS} from '../../constants/api';
import ReviewsTSEdit from './ReviewsTSEdit';
import ReviewsTSDelete from './ReviewsTSDelete';

const ReviewsRTPage = ({history, ...props}) => {
  const subheader = useSubheader();
  const ref = React.createRef();
  useEffect(() => {
    subheader.setTitle('Avis');
  }, [subheader]);

  const roadTripComponent = useCallback((r) => {
    return (
      <span
        key={r.id}
        className={'d-inline-block text-truncate'}
        style={{maxWidth: '200px'}}
        data-toggle="tooltip"
        data-placement="bottom"
        title={`${r.road_trip.id} - ${r.road_trip.title}`}
      >
        {r.road_trip.id} - {r.road_trip.title}
      </span>
    );
  }, []);

  const commentComponent = useCallback((r) => {
    return (
      <span
        key={r.id}
        className={'d-inline-block text-truncate'}
        style={{maxWidth: '200px'}}
        data-toggle="tooltip"
        data-placement="bottom"
        title={`${r.content}`}
      >
        {r.content}
      </span>
    );
  }, []);

  const dateComponent = useCallback((r) => {
    return <span key={r.id}>{new Date(r.created_at).toLocaleDateString()}</span>;
  }, []);
  const columns = [
    {
      field: 'id',
      title: 'ID',
      type: 'numeric',
      filtering: false,
      sorting: true,
    },
    {
      field: 'road_trip_id',
      title: 'Road Trips',
      filtering: true,
      sorting: false,
      render: roadTripComponent,
      width: '100%',
    },
    {
      field: 'note',
      title: 'Note',
      filtering: false,
      sorting: true,
    },
    {
      field: 'content',
      title: 'Contenu',
      render: commentComponent,
      filtering: false,
      sorting: false,
      width: '100%',
    },
    {
      field: 'created_at',
      title: 'Date de création',
      render: dateComponent,
      filtering: false,
      sorting: true,
    },
  ];
  const actions = [
    {
      icon: 'view_column',
      tooltip: 'Voir',
      onClick: (event, rowData) => history.push(REVIEWS_RT_EDIT(rowData.id)),
    },
    {
      icon: 'delete',
      tooltip: 'Supprimer',
      onClick: (event, rowData) => history.push(REVIEWS_RT_DELETE(rowData.id)),
    },
  ];
  return (
    <>
      <Card className="p-4 rounded-lg shadow-sm">
        <h3 className="m-0">Gestion des avis</h3>
        <p className="text-muted">Gérer les avis de vos Road Trips</p>
        <MyTable
          ref={ref}
          columns={columns}
          apiUrl={API_GET_ALL_REVIEWS('rt')}
          actions={actions}
        />
      </Card>
      <Switch>
        <Route path={REVIEWS_RT_EDIT(':id')}>
          {({history, match}) => (
            <ReviewsTSEdit
              road_trips={true}
              refresh={ref}
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(REVIEWS_RT);
              }}
            />
          )}
        </Route>
        <Route path={REVIEWS_RT_DELETE(':id')}>
          {({history, match}) => (
            <ReviewsTSDelete
              road_trips={true}
              refresh={ref}
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(REVIEWS_RT);
              }}
            />
          )}
        </Route>
      </Switch>
    </>
  );
};

export default ReviewsRTPage;
